import { Injectable } from '@angular/core';
import {
  Account,
  createPostObject,
  Post,
  Source,
} from '@jaimo-solutions-gmbh/platform-services-module';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storedStreams: StoredStream[] = [];
  private storedFilters: StoredFilter[] = [];
  private storedLinklist: StoredLinklist[] = [];
  private storedSources: StoredSources[] = [];
  private storedAccounts: Account[] = [];

  constructor() {}

  saveStreamContent(handle, filter, entries) {
    if (!filter) {
      filter = 'mixed';
    }

    const foundStream = this.storedStreams.find(
      (stream) => stream.handle == handle
    );

    if (foundStream) {
      const storedEntries: StoredEntries = {
        filter,
        entries,
      };
      const foundType = foundStream.filterEntries.find(
        (x) => x.filter === filter
      );
      const index = foundStream.filterEntries.indexOf(foundType);
      if (index > -1) {
        foundStream.filterEntries[index] = storedEntries;
      } else {
        foundStream.filterEntries.push(storedEntries);
      }
    } else {
      const filterEntries: StoredEntries[] = [{ filter, entries }];
      const stream: StoredStream = {
        handle: handle.toString(),
        filterEntries,
      };
      this.storedStreams.push(stream);
    }
  }

  getStored(
    type: 'account' | 'stream' | 'filters' | 'linklist' | 'sources',
    handle: string,
    filter?: string
  ) {
    switch (type) {
      case 'account':
        return this.storedAccounts.find((x) => x.handle === handle);
      case 'stream':
        const stream = this.storedStreams.find(
          (stream) => stream.handle === handle.toString()
        );
        if (!stream) return;

        return stream.filterEntries.find(
          (x) => x.filter === (filter ?? 'mixed')
        );
      case 'filters':
        return this.storedFilters.find((x) => x.handle === handle)?.filters;
      case 'linklist':
        return this.storedLinklist.find((x) => x.handle === handle)?.linklists;
      case 'sources':
        return this.storedSources.find((x) => x.handle === handle)?.sources;
      default:
        break;
    }
  }

  getStreamContent(handle, filter): Post[] {
    const stream = this.storedStreams.find(
      (x) => x.handle === handle.toString()
    );
    if (stream) {
      if (!filter) {
        filter = 'mixed';
      }
      return stream.filterEntries
        .find((x) => x.filter == filter)
        .entries.map(createPostObject);
    }
  }

  saveAccount(account: Account) {
    if (!this.storedAccounts.find((x) => x == account)) {
      this.storedAccounts.push(account);
    }
  }

  saveAccountFilter(handle, filter) {
    if (!this.storedFilters.find((x) => x.handle === handle)) {
      const storedFilter: StoredFilter = { handle, filters: filter };
      this.storedFilters.push(storedFilter);
    }
  }

  saveLinks(handle, linklist) {
    if (!this.storedLinklist.find((x) => x.handle === handle)) {
      const storedLinklist: StoredLinklist = { handle, linklists: linklist };
      this.storedLinklist.push(storedLinklist);
    }
  }

  saveSource(handle, source) {
    if (!this.storedSources.find((x) => x.handle === handle)) {
      const storedSources: StoredSources = { handle, sources: source };
      this.storedSources.push(storedSources);
    }
  }
}

interface StoredStream {
  handle: string;
  filterEntries: StoredEntries[];
}

interface StoredEntries {
  filter: string;
  entries: any[];
}

interface StoredLinklist {
  handle: string;
  linklists: any[];
}

interface StoredFilter {
  handle: string;
  filters: any[];
}

interface StoredSources {
  handle: string;
  sources: Source[];
}
